import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 37 37" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fill={color} fillRule="nonzero">
            <path d="M36.458 0H.542C.242 0 0 .243 0 .542v35.916c0 .3.243.542.542.542h35.916c.3 0 .542-.243.542-.542V.542c0-.3-.243-.542-.542-.542zm-.542 35.916H1.084V1.084h34.832v34.832z"/>
            <path d="M34.282 2.176H2.718c-.299 0-.542.243-.542.542v3.25a.542.542 0 0 0 1.084 0V3.26h30.48v30.48H3.26V8.135a.542.542 0 0 0-1.084 0v26.147c0 .299.243.542.542.542h31.564c.299 0 .542-.243.542-.542V2.718c0-.299-.243-.542-.542-.542z"/>
            <path d="M20.405 7.721a1.998 1.998 0 0 0-2.226.684l-3.628 4.772a1.986 1.986 0 0 0 .386 2.785c.35.264.766.404 1.203.404.631 0 1.211-.288 1.592-.788l.042-.055v10.783c0 1.096.895 1.988 1.995 1.988s1.996-.892 1.996-1.988v-16.7c0-.855-.547-1.612-1.36-1.885zm.271 18.585a.906.906 0 0 1-1.814 0V13.909a.542.542 0 0 0-.544-.542.545.545 0 0 0-.433.215l-1.02 1.341a.902.902 0 0 1-.725.358.903.903 0 0 1-.722-1.45l3.628-4.77a.913.913 0 0 1 1.012-.312c.37.124.618.468.618.857v16.7z"/>
        </g>
    </svg>
)

export default class IconFieldNumber extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
